module.exports = __webpack_public_path__ + "static/img/filtr_prirubovy.67874a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/filtr_prirubovy.png
// module id = IkJG
// module chunks = 1